import React from 'react';
import ProductPage from '../components/ProductPage';
import useDocumentTitle from '../hooks/useDocumentTitle';
import PrzyciskAsystenta from '../components/kreator/PrzyciskAsystenta';
import { useTranslation } from 'react-i18next';

const Panels = () => {
  const { t } = useTranslation('lista');
  useDocumentTitle(t('tytul_strony.panel'));
  return (
    <div className='space-y-10'>
      <ProductPage
        productType="panel"
        akcja={(
          <PrzyciskAsystenta
            to="/dobor-modulow"
            tytul={t('asystent.panel')}
            narzedzie={t('asystent.narzedzie')}
          />
        )}
      />
    </div>
  )
}

export default Panels;
